<template>
  <v-dialog v-model="value" persistent scrollable max-width="1000">
    <v-card v-if="!loading">
      <v-layout>
        <v-flex></v-flex>
        <v-flex shrink>
          <v-btn flat fab small @click="onCancel">
            <v-icon> close </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-divider />
      <v-card-text style="height: 500px">
        Campaign Name*
        <v-text-field
          id="name"
          v-model="data.name"
          v-validate="'required'"
          name="name"
          single-line
          :error="errors.has('name')"
          :error-messages="errors.first('name')"
          autofocus
          flat
          class="default-input"
          outline
        ></v-text-field>

        <v-layout row wrap class="default-input">
          <v-flex xs6 class="pr-1">
            Start Date
            <datepicker v-model="data.start_date" color="primary" @selected="onSelectedStartDate">
              <template #default="{ computedDate }">
                <v-text-field
                  id="id"
                  name="date"
                  single-line
                  flat
                  :value="computedDate"
                  outline
                  hide-details
                  disabled
                  class="custom-text-date-picker"
                ></v-text-field>
              </template>
            </datepicker>
          </v-flex>
          <v-flex xs6>
            End Date
            <datepicker v-model="data.end_date" color="primary" @selected="onSelectedEndDate">
              <template #default="{ computedDate }">
                <v-text-field
                  id="id"
                  name="date"
                  single-line
                  flat
                  :value="computedDate"
                  outline
                  hide-details
                  disabled
                  class="custom-text-date-picker"
                ></v-text-field>
              </template>
            </datepicker>
          </v-flex>
        </v-layout>

        Trigger After*
        <v-select
          id="trigger_after"
          v-model="data.trigger_after"
          v-validate="'required'"
          name="trigger_after"
          data-vv-as="Trigger after"
          single-line
          :error="errors.has('trigger_after')"
          :error-messages="errors.first('trigger_after')"
          autofocus
          flat
          class="default-input"
          outline
          :items="triggerAfterItems"
        ></v-select>

        <template v-if="data.trigger_after == 'บทสนทนา'">
          Conversation*
          <v-autocomplete
            id="intent"
            v-model="data.intent"
            v-validate="'required'"
            name="intent"
            data-vv-as="Conversation"
            single-line
            :error="errors.has('intent')"
            :error-messages="errors.first('intent')"
            autofocus
            flat
            class="default-input"
            outline
            :items="intentItems"
            item-value="id"
            item-text="intentname"
          ></v-autocomplete>
        </template>

        Messages*
        <v-layout row>
          <v-flex
            class="form-control"
            :class="{
              'has-error': errors.has('messages')
            }"
          >
            <autoresize-textarea
              id="messages"
              ref="messages"
              v-model="data.messages"
              v-validate="'required'"
              name="messages"
              data-vv-as="Messages"
              single-line
              :error="errors.has('messages')"
              :error-messages="errors.first('messages')"
              autofocus
              flat
              outline
              maxlength="2000"
              counter
              style="resize: none; display: inherit; margin-bottom: 5px"
            ></autoresize-textarea>
            <v-layout>
              <v-flex>
                <span v-show="errors.has('messages')" class="text-error">{{
                  errors.first('messages')
                }}</span>
              </v-flex>
              <v-flex shrink>{{ data.messages ? data.messages.length : 0 }}/2000</v-flex>
            </v-layout>

            <!-- <v-textarea></v-textarea> -->
          </v-flex>
          <v-flex shrink>
            <!-- <IntentPrefill :custom="customIntentPrefill" @addIntentPrefill="addPrefill"></IntentPrefill> -->
            <IntentPrefill :prefills="prefills" @addIntentPrefill="addPrefill"></IntentPrefill>
          </v-flex>
        </v-layout>

        <v-layout style="align-items: center">
          <toggle-button
            v-model="data.is_followup_schedule"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            @change="handleChangeFollowupSchedule"
          />
          <v-flex class="pl-2">ตั้งเวลาการส่งข้อความ Follow up message </v-flex>
        </v-layout>

        <div>
          <div class="mt-2">ส่งข้อความตามไปในเวลา...</div>
          <GeneraliTimePicker v-model="data.followup_schedule_time" />
          <input
            v-model="data.followup_schedule_time"
            v-validate="data.is_followup_schedule ? 'required|min_value:1' : ''"
            name="followup_schedule_time"
            :data-vv-as="'เวลา'"
            type="hidden"
          />
          <div v-if="errors.has('followup_schedule_time')" class="error--text">
            {{ errors.first('followup_schedule_time') }}
          </div>
        </div>

        Send Limit
        <v-text-field
          id="send_limit"
          v-model="data.send_limit"
          name="send_limit"
          single-line
          :error="errors.has('send_limit')"
          :error-messages="errors.first('send_limit')"
          class="default-input"
          autofocus
          flat
          outline
          @keypress="isNumber"
        ></v-text-field>

        Please select User
        <v-select
          id="limit_by_user"
          v-model="data.limit_by_user"
          name="limit_by_user"
          single-line
          flat
          class="default-input"
          outline
          :items="limitByOption"
        ></v-select>

        <div class="d-flex">
          <v-layout class="z-border-red pa-2" wrap>
            <v-flex xs12>
              <v-layout>
                <v-flex class="d-flex">
                  <div class="px-3 pt-3">จำนวนสิทธิ์ตลอดแคมเปญ *</div>
                  <v-text-field
                    id="limit"
                    v-model="data.limit"
                    v-validate="'required'"
                    name="limit"
                    single-line
                    :placeholder="$t('Count')"
                    :data-vv-as="$t('limit_campaign')"
                    class="default-input"
                    autofocus
                    flat
                    outline
                    :error="errors.has('limit')"
                    :error-messages="errors.first('limit')"
                    @keypress="isNumber"
                  ></v-text-field>
                  <div class="px-3 pt-3">สิทธิ์</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <div class="caption grey--text lighten-2 pt-2">
                NOTE: หากไม่ต้องการกำหนดสิทธิ์ให้ใส่ตัวเลขจำนวนมากๆ เช่น 100,000
              </div>
            </v-flex>
          </v-layout>
          <v-layout class="z-border-red pa-2 ml-2" wrap>
            <v-flex xs12>
              <v-layout>
                <v-flex style="display: flex">
                  <div class="px-3 pt-3">จำกัดสิทธิ์ในการแลก *</div>
                  <v-text-field
                    id="limit_period"
                    v-model="data.limit_period"
                    v-validate="'required'"
                    name="limit_period"
                    single-line
                    :placeholder="$t('Count')"
                    :data-vv-as="$t('limit_period')"
                    class="default-input"
                    flat
                    outline
                    :error="errors.has('limit_period')"
                    :error-messages="errors.first('limit_period')"
                    @keypress="isNumber"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pl-3 d-flex">
                  <div class="px-3 pt-3">/</div>
                  <v-select
                    id="period_type"
                    v-model="data.period_type"
                    v-validate="'required'"
                    name="period_type"
                    data-vv-as="Period type"
                    single-line
                    flat
                    class="default-input"
                    outline
                    :items="formatOption"
                    :error="errors.has('period_type')"
                    :error-messages="errors.first('period_type')"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <div class="mt-3">
          Upload Codes {{ item && item.codes ? item.codes.length : 0 }} Code(s)
          <span v-if="codes" class="primary--text">(Replace code: {{ countAllCodes }} Codes)</span>
          <importxlsx :loading="loading" @onChange="onImport">
            <template #default="{ loading, onClickUploadButton }">
              <v-btn :loading="loading" outline color="primary" @click="onClickUploadButton">
                <em class="fas fa-file-upload mr-2" />Import
              </v-btn>
            </template>
          </importxlsx>
          <v-dialog
            v-model="showImportInfo"
            scrollable
            persistent
            max-width="500px"
            transition="dialog-transition"
          >
            <template #activator="{ on }">
              <v-btn icon small v-on="on"><v-icon color="primary">info</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-btn small icon @click="showImportInfo = false"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <strong>วิธีการ Import code เข้าไปในระบบ:</strong>

                <p>
                  User จะต้องทำการ import code โดยใช้ template excel ตามที่บริษัทได้มอบให้
                  เมื่อกดปุ่ม Import ที่หน้า Add campaign เรียบร้อย ให้ทำการเลือกไฟล์ template excel
                  ที่ได้กรอก code ที่จะใช้สำหรับ campaign แล้ว เมื่อเลือกไฟล์แล้ว ข้อมูล group code
                  และ จำนวน code จะแสดงผลที่หน้าจอให้
                </p>
                <p>
                  หลังจากนั้น ให้กลับไปที่ปุ่มจุด 3 จุดข้างช่องกรอกข้อความ เพื่อที่จะเพิ่ม function
                  ของ code ที่ได้มีการ import ไปก่อนหน้านี้ และ code
                  ก็จะแสดงผลที่ข้อความของลูกค้าได้อย่างที่ตั้งใจ
                </p>
                <p>
                  *Function code ที่แสดงอยู่ในปุ่มกดจุด 3 จุดนี้ จะอิงตาม group code ที่ user
                  ได้มีการใส่ข้อมูลเข้าไปในไฟล์และ import เข้าไปก่อนหน้านี้
                </p>
                <p>
                  *Function code จะแสดงผลขึ้นมาให้เห็นก็ต่อเมื่อได้มีการ import code
                  เข้าระบบเรียบร้อยเท่านั้น
                </p>

                <p>
                  หาก user ได้ import code และได้ insert function code เข้าไปในข้อความ
                  และกรอกข้อมูลส่วนอื่นเรียบร้อย ให้กดปุ่ม save เพื่อให้ follow-up message
                  นี้ได้เริ่มใช้งาน
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <template v-if="countCodes">
          <div v-for="(qty, code) in countCodes" :key="code">
            <span>{</span><span style="text-transform: lowercase">{{ code }}</span
            ><span>}</span> : {{ qty.count }} Code(s)
          </div>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn outline color="grey" @click="onCancel">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn depressed color="primary" @click="onSave">
          {{ $t('Save') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import datepicker from '@/components/elements/DatepickerCustomDialog'
import importxlsx from '@/components/elements/importxlsx.vue'
import { mapGetters } from 'vuex'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import { ToggleButton } from 'vue-js-toggle-button'
import GeneraliTimePicker from './GeneraliTimePicker.vue'
export default {
  components: {
    datepicker,
    importxlsx,
    IntentPrefill,
    AutoresizeTextarea,
    ToggleButton,
    GeneraliTimePicker
  },
  props: ['value', 'item'],
  data() {
    return {
      showStartDate: false,
      showEndDate: false,
      showImportInfo: false,
      data: {
        name: null,
        start_date: null,
        end_date: null,
        trigger_after: null,
        messages: null,
        limit: null,
        limit_by_user: null,
        limit_period: null,
        period_type: 'วัน',
        send_limit: null,
        codes: [],
        is_followup_schedule: false,
        followup_schedule_time: null // minutes
      },
      followup_schedule_time: null,
      loading: false,
      triggerAfterItems: ['taxcert', 'รับผลประโยชน์', 'บทสนทนา'],
      formatOption: ['วัน', 'เดือน', 'ปี'],
      limitByOption: ['All', 'เคยสมัคร Line Connect', 'ไม่เคยสมัคร Line Connect'],
      codes: null,
      countCodes: [],
      countAllCodes: 0,
      customIntentPrefill: [],
      prefills: [
        {
          name: this.$t('Insert') + this.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('last name'),
          value: 'last_name',
          description: ''
        }
      ]
    }
  },
  async mounted() {
    this.loading = true
    if (this.item) this.data = this.item

    if (this.data.codes) {
      let allCodes = this.data.codes
      let countCode = {}
      allCodes.forEach((el) => {
        countCode[el.code_type] = countCode[el.code_type] || { count: 0 }
        countCode[el.code_type].count++
      })
      this.countCodes = { ...countCode }
      this.onGeneratePrefill(countCode)
    }

    await this.$nextTick()
    this.errors.clear()
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    intentItems() {
      // TODO: ทำ search ได้
      return this.$store.getters.getIntents('intent')
        ? this.$store.getters.getIntents('intent')
        : []
    }
  },
  methods: {
    handleChangeFollowupSchedule(payload) {
      this.$set(this.data, 'is_followup_schedule', payload.value)
      if (this.data.is_followup_schedule == false) {
        this.followup_schedule_time = null
      }
    },
    addPrefill(prefill) {
      if (!this.$refs['messages']) return false
      let cursorPosition = this.$refs['messages'].$el.selectionStart

      if (cursorPosition) {
        this.$set(
          this.data,
          'messages',
          [
            this.data.messages.slice(0, cursorPosition),
            '{' + prefill + '}',
            this.data.messages.slice(cursorPosition)
          ].join('')
        )
      } else {
        if (!this.data.messages) {
          this.$set(this.data, 'messages', [this.data.messages, '{' + prefill + '}'].join(''))
        } else {
          // this.$set(this.data, 'messages', [this.data.messages, '{' + prefill + '}'].join(''))
          this.$set(
            this.data,
            'messages',
            [this.data.messages.slice(0, 0), '{' + prefill + '}', this.data.messages].join('')
          )
        }
      }
    },
    onCancel() {
      this.onClose()
    },
    async onSave() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      // eslint-disable-next-line no-undef
      let data = _.cloneDeep(this.data)
      if (this.codes) {
        data.codes = this.codes
      }
      if (!data.is_followup_schedule) {
        data.followup_schedule_time = 0
      }
      try {
        let endpoint = data.id ? 'putFollowMessage' : 'postFollowMessage'

        let response = await api[endpoint]({ pageid: this.selectedBot.pageid, data: data })

        if (response.status) {
          this.$emit('onSaveCampaign')
        }

        // this.$emit('onChange', response.status)
      } catch (error) {
        console.error(error)
      }
      this.onClose()
    },
    isNumber(value) {
      let val = null
      try {
        val = parseInt(value)
      } catch (error) {
        return false
      }
      return typeof val === 'number' && isFinite(val)
    },
    onClose() {
      this.$emit('input', false)
      this.$emit('onChange', null)
    },
    onSelectedStartDate(value, time) {
      if (moment(this.data.end_date).isBefore(value)) {
        this.data.end_date = value
      }
      if (!time) {
        this.data.start = value
      }
      this.showStartDate = false
    },
    onSelectedEndDate(value, time) {
      if (moment(value).isBefore(this.data.start_date)) {
        this.data.start_date = value
      }
      if (!time) {
        this.data.end_date = value
      }
      this.showEndDate = false
    },
    onImport(file) {
      let allCodes = file[0]
      let countCode = {}

      allCodes.forEach((el) => {
        Object.keys(el).forEach((key) => {
          countCode[key] = countCode[key] || { count: 0 }
          countCode[key].count++
          this.countAllCodes++
        })
      })

      this.onGeneratePrefill(countCode)
      this.countCodes = { ...countCode }
      this.codes = file[0]
    },
    onGeneratePrefill(code) {
      let customIntents = Object.keys(code)
      customIntents.forEach((intent) => {
        let obj = {}
        Object.assign(obj, {
          name: this.$t('Insert') + intent.toLowerCase(),
          value: intent.toLowerCase(),
          description: ''
        })
        this.prefills.push(obj)
      })

      // const customIntentPrefill = Object.keys(code);
      // this.customIntentPrefill = customIntentPrefill;
    }
  }
}
</script>

<style lang="scss">
.custom-text-date-picker input[type='text']:not(.browser-default):disabled {
  border-bottom: 0 !important;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/FollowupMessageManage.vue